import authEn from './en/en.json'
import authAr from './ar/ar.json'
import authEs from './es/es.json'
import authDe from './de/de.json'
import authIt from './it/it.json'
import authFr from './fr/fr.json'
import authPt from './pt/pt.json'
import authEl from './el/el.json'
import authBn from './bn/bn.json'
import authSr from './sr/sr.json'
import authCs from './cs/cs.json'
import authPl from './pl/pl.json'
import authHu from './hu/hu.json'
import authSk from './sk/sk.json'
import authRo from './ro/ro.json'
import authBg from './bg/bg.json'
import authMk from './mk/mk.json'
import authSq from './sq/sq.json'

const AuthMessages = {
  en: { auth: { ...authEn } },
  ar: { auth: { ...authAr } },
  es: { auth: { ...authEs } },
  de: { auth: { ...authDe } },
  it: { auth: { ...authIt } },
  fr: { auth: { ...authFr } },
  pt: { auth: { ...authPt } },
  el: { auth: { ...authEl } },
  bn: { auth: { ...authBn } },
  sr: { auth: { ...authSr } },
  cs: { auth: { ...authCs } },
  pl: { auth: { ...authPl } },
  hu: { auth: { ...authHu } },
  sk: { auth: { ...authSk } },
  ro: { auth: { ...authRo } },
  bg: { auth: { ...authBg } },
  mk: { auth: { ...authMk } },
  sq: { auth: { ...authSq } },
}

export default AuthMessages
